"use strict";

exports.__esModule = true;
exports.drawRadialLabels = exports.drawSliceLabels = void 0;

var _core = require("@nivo/core");

var _compute = require("./compute");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const drawSliceLabels = (ctx, arcs, {
  arcGenerator,
  getLabel,
  skipAngle,
  getTextColor,
  theme
}) => {
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.font = theme.labels.text.fontSize + "px " + theme.labels.text.fontFamily;
  arcs.filter(arc => skipAngle === 0 || arc.angleDeg > skipAngle).forEach(arc => {
    const _arcGenerator$centroi = arcGenerator.centroid(arc),
          centroidX = _arcGenerator$centroi[0],
          centroidY = _arcGenerator$centroi[1];

    const sliceLabel = getLabel(arc.data);
    const textColor = getTextColor(arc, theme);
    ctx.save();
    ctx.translate(centroidX, centroidY);
    ctx.fillStyle = textColor;
    ctx.fillText(sliceLabel, 0, 0);
    ctx.restore();
  });
};

exports.drawSliceLabels = drawSliceLabels;

const drawRadialLabels = (ctx, arcs, {
  radius,
  getLabel,
  skipAngle,
  linkOffset,
  linkDiagonalLength,
  linkHorizontalLength,
  linkStrokeWidth,
  textXOffset,
  getTextColor,
  getLinkColor,
  theme
}) => {
  const radialLabels = (0, _compute.computeRadialLabels)(arcs, {
    getLabel,
    radius,
    skipAngle,
    linkOffset,
    linkDiagonalLength,
    linkHorizontalLength,
    textXOffset
  });
  ctx.textBaseline = 'middle';
  ctx.font = theme.labels.text.fontSize + "px " + theme.labels.text.fontFamily;
  radialLabels.forEach(label => {
    const dataWithColor = _extends({}, label.arc.data, {
      color: label.arc.color
    });

    ctx.save();
    ctx.translate(label.position.x, label.position.y);
    ctx.fillStyle = getTextColor(dataWithColor, theme);
    ctx.textAlign = _core.textPropsByEngine.canvas.align[label.align];
    ctx.fillText(label.text, 0, 0);
    ctx.restore();
    ctx.beginPath();
    ctx.strokeStyle = getLinkColor(dataWithColor, theme);
    ctx.lineWidth = linkStrokeWidth;
    label.line.forEach((point, index) => {
      if (index === 0) ctx.moveTo(point.x, point.y);else ctx.lineTo(point.x, point.y);
    });
    if (linkStrokeWidth > 0) ctx.stroke();
  });
};

exports.drawRadialLabels = drawRadialLabels;